import React from 'react';
import { Modal } from 'htlib-copy';
import { func, bool } from 'prop-types';

import customTypes from 'types';
import { usePatchChecks } from 'hooks/checks';
import { IMAGES_BASE_URL } from 'utils/constants';

import { useUrlParam } from '../utils';
import Localization from './Localization';
import TileActions from './TileActions';

import './index.scss';

export default function ImageTile({ check, onLoad, canLoad }) {
  const { check: checkObj, id, imageMd5, indexName, labeling } = check;
  const patchChecksMutation = usePatchChecks(id);

  const { getUrlParam } = useUrlParam();
  const entityId = getUrlParam('entity');

  const imgSrc = `${IMAGES_BASE_URL}/${imageMd5}`;

  const [showModal, setShowModal] = React.useState(false);

  function setCheckClass() {
    if (!checkObj) return '';

    let cssClass = checkObj[entityId] === labeling[entityId] ? '' : checkObj[entityId];

    if (cssClass === undefined) {
      cssClass =
        checkObj.checkNoForAll && checkObj.checkNoForAll !== checkObj.labelingNoForAll ? '' : 'no';
    }

    return `--${cssClass}`;
  }

  const checkClass = setCheckClass();

  return (
    <div className="ImageTile">
      <div className={`Check ${checkClass}`}>
        <p className="ImageTile__indexName" title={indexName}>
          {indexName}
        </p>

        <div onClick={() => setShowModal(true)}>
          <Localization onLoad={onLoad} canLoad={canLoad} coords={check.coords} src={imgSrc} />
        </div>

        <TileActions indexName={indexName} checkId={id} patchChecks={patchChecksMutation.mutate} />
      </div>

      {showModal && (
        <Modal
          onClose={() => {
            setShowModal(false);
          }}
        >
          <div className="LightBox">
            <Localization onLoad={onLoad} canLoad={canLoad} coords={check.coords} src={imgSrc} />
          </div>
        </Modal>
      )}
    </div>
  );
}

ImageTile.propTypes = {
  check: customTypes.check.singleCheck,
  onLoad: func.isRequired,
  canLoad: bool.isRequired,
};

ImageTile.defaultProps = {
  check: {},
};
